import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Router, RouteReuseStrategy } from '@angular/router';
import { LOCALE_ID } from '@angular/core';
import { routes } from './app.routes';
import { httpAuthInterceptor } from './core/interceptors/http-auth.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import * as Sentry from "@sentry/angular";
import { TraceService } from '@sentry/angular';
import { RouteNoReuseStrategy } from './core/strategies/route-no-reuse.strategy';
import { DEFAULT_LANGUAGE, TranslationService } from './core/services/translation/translation.service';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';
import {NgxMonacoEditorConfig, provideMonacoEditor} from 'ngx-monaco-editor-v2';

import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

const monacoConfig: NgxMonacoEditorConfig = {
  // absolute base url, so workers don't resolve from blob:
  baseUrl: `${location.origin}/assets/monaco/min/vs`,
  defaultOptions: {
    automaticLayout: true
  }
};

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: RouteReuseStrategy,
      useClass: RouteNoReuseStrategy
    },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideMonacoEditor(monacoConfig),
    provideHttpClient(
      withInterceptors([httpAuthInterceptor])),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    }),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader
      },
      fallbackLang: DEFAULT_LANGUAGE
    }),
    TranslationService,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark'
        }
      }
    })
  ]
};
